import {
    createProvider
} from 'react-redux';

export default createProvider('cmp_store');